import React from "react";
import { useNavigate } from "react-router-dom";
import { useMenu } from "./contexts/MenuContext";
import { NO_ACCESS_ROUTE } from "./services/menuService";
import { useCapabilities } from "./contexts/CapabilitiesContext";

export default function NoAccessPage({
  allowRetry = false,
  description,
  title = "Access Denied",
}) {
  const navigate = useNavigate();
  const { getDefaultMenuPath, menuError, menuItems, refreshMenuItems } = useMenu();
  const { error: capabilitiesError, refreshCapabilities } = useCapabilities();
  const homePath = getDefaultMenuPath();
  const hasAssignedModules = Array.isArray(menuItems) && menuItems.length > 0;
  const resolvedDescription =
    capabilitiesError ||
    menuError ||
    description ||
    (hasAssignedModules
      ? "You do not have access to this module. Please contact your administrator."
      : "No modules assigned. Please contact your administrator.");

  const handleRetry = () => {
    refreshMenuItems();
    refreshCapabilities();
  };

  const handleGoHome = () => {
    navigate(homePath, { replace: true });
  };

  return (
    <div className="loader-container">
      <div
        style={{
          background: "#ffffff",
          border: "1px solid #dbe1ef",
          borderRadius: "18px",
          boxShadow: "0 10px 30px rgba(20, 25, 93, 0.08)",
          maxWidth: "560px",
          padding: "32px",
          textAlign: "center",
          width: "100%",
        }}
      >
        <h1
          style={{
            color: "#14195d",
            fontSize: "28px",
            fontWeight: 700,
            margin: "0 0 12px",
          }}
        >
          {title}
        </h1>
        <p style={{ color: "#5f6987", fontSize: "15px", margin: 0 }}>
          {resolvedDescription}
        </p>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            marginTop: "24px",
          }}
        >
          {allowRetry ? (
            <button
              className="masters-btn masters-btn--secondary"
              onClick={handleRetry}
              type="button"
            >
              Retry
            </button>
          ) : null}
          {homePath !== NO_ACCESS_ROUTE ? (
            <button className="masters-btn" onClick={handleGoHome} type="button">
              Go To Available Module
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
